import axios from "axios";
import { APP_SETTINGS } from "../../config";

//Get Employee List
export function getEmployeeList(data) {
  return axios.post(APP_SETTINGS.API_PATH.WORKLOAD.getEmployeeList, data);
}

//Get Project List
export function getProjectList(data) {
  return axios.post(APP_SETTINGS.API_PATH.WORKLOAD.getProjectList, data);
}

//Get Task List
export function getWorkLoadTaskList(data) {
  return axios.post(APP_SETTINGS.API_PATH.WORKLOAD.getTaskList, data);
}

//Get Employee List By Project Id
export function getWorkLoadEmployeeListByProjectId(data) {
  return axios.post(
    APP_SETTINGS.API_PATH.WORKLOAD.getEmployeeListByProjectId,
    data
  );
}
export function getEmployeeWorkLoadByUserIdApi(data) {
  return axios.post(
    `${APP_SETTINGS.API_PATH.WORKLOAD.getEmployeeWorkLoadByUserId}?userId=${data?.userId}`
  );
}
export function getTaskDetailsByUserIdApi(data) {
  return axios.post(
    APP_SETTINGS.API_PATH.WORKLOAD.getTaskDetailsByUserId,
    data
  );
}
